import { render } from "./PR35-01282024.vue?vue&type=template&id=0232cef9"
import script from "./PR35-01282024.vue?vue&type=script&lang=js"
export * from "./PR35-01282024.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__